import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { snackBar } from "@/store/useNotificationSnackBar";
import { eTypeSnackBar } from "@/types/ui";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationSnackbar',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    color: _unref(snackBar).type,
    timeout: 2000,
    modelValue: _unref(snackBar).visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(snackBar).visible) = $event))
  }, {
    default: _withCtx(() => [
      (_unref(snackBar).type === _unref(eTypeSnackBar).success)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            size: "x-large",
            icon: "mdi-thumb-up"
          }))
        : (_openBlock(), _createBlock(_component_v_icon, {
            key: 1,
            size: "x-large",
            icon: "mdi-alert-outline"
          })),
      _createTextVNode(" " + _toDisplayString(_unref(t)(_unref(snackBar).message)), 1)
    ]),
    _: 1
  }, 8, ["color", "modelValue"]))
}
}

})